import { elsterDocxUtils, emptyLine } from '../utils/elster_docx_utils';
import i18n from 'i18next';
import generalTable from '../utils/generalTable';
import { grayTitlesMain } from '../styles/elsterDocStyles';
import { IORADO_PROJECTS_EIGHT, IORADO_PROJECTS_SEVEN, IORADO_PROJECTS_SIX } from '../constants/elsterDocxConstants';
const projectContractors = (elsterProject, mainParagraphOptions) => {
  const {
    t
  } = i18n;
  const {
    createTextRunInParagraph
  } = elsterDocxUtils;
  const contractors = elsterProject === null || elsterProject === void 0 ? void 0 : elsterProject.project_contractors;
  if (!Array.isArray(contractors)) {
    return [];
  }
  return contractors.flatMap(contractor => {
    return [createTextRunInParagraph(t('iorado_only_for_contract_research'), grayTitlesMain, mainParagraphOptions), generalTable(contractor, IORADO_PROJECTS_SIX), createTextRunInParagraph(t('iorado_contractors_data'), grayTitlesMain, mainParagraphOptions), generalTable(contractor, IORADO_PROJECTS_SEVEN), createTextRunInParagraph(t('only_when_received_or_applying_for_other_subsidies'), grayTitlesMain, mainParagraphOptions), generalTable(contractor, IORADO_PROJECTS_EIGHT), emptyLine];
  });
};
export default projectContractors;